import React, { FC, Fragment } from 'react';
import { Grid } from '@mui/material';
import { RowSection as RowSectionType } from 'features/document/documentSlice';
import ViewerColumnSection from '../ViewerColumnSection/ViewerColumnSection';
import styles from './ViewerRowSection.module.css';

interface ViewerRowSectionProps {
  row: RowSectionType;
}

const ViewerRowSection: FC<ViewerRowSectionProps> = ({ row }) => {
  return (
    <Fragment>
      <Grid flexDirection='column' className={styles.container}>
        <Grid item>
          <Grid container justifyContent='space-around' flexWrap='nowrap'>
            {row.columns.map(column => {
              return (
                <Grid key={column.id} item xs>
                  <ViewerColumnSection column={column} />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ViewerRowSection;
